import {SlackService} from '../../libs/ui/src';

import {client} from '../apiService';
const _SlackService = new SlackService({client});
export {_SlackService as SlackService};
